<template>
  <div class="tableContainer">
    <DxDataGrid
      ref="dataGrid"
      :data-source="europeanChains[0].cadenas"
      :show-borders="false"
      :show-column-lines="false"
      :allow-column-reordering="false"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :show-column-headers="true"
      :show-colon="false"
      :remote-operations="true"
      :hover-state-enabled="true"
      :show-row-lines="false"
      :row-alternation-enabled="false"
      :no-data-text="$t('noDataText')"
      class="custom-grid custom-grid-chains"
      @toolbar-preparing="onToolbarPreparing($event)"
      @exporting="onExporting"
      @initialized="onGridInitialized"
    >
      <DxHeaderFilter :visible="true" />
      <DxScrolling mode="standard" />
      <DxSelection mode="single" />
      <DxPaging :page-size="10" />
      <DxStateStoring
        :enabled="true"
        type="localStorage"
        storage-key="chains-grid"
      />
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[5, 10, 20]"
        :show-info="true"
        info-text="{2} items"
        :visible="true"
      />

      <DxSearchPanel
        :visible="true"
        :width="300"
        :placeholder="$t('search')"
      />

      <DxColumn
        name="chain"
        data-field="Supermercado"
        :caption="$t('chain')"
        :allow-sorting="false"
        alignment="left"
        :fixed="true"
        fixed-position="left"
        :allow-header-filtering="true"
        :header-filter="{ allowSearch: true }"
      />

      <DxColumn
        name="lmr_ue"
        :caption="$t('chainsList.% LMR UE')"
        :allow-sorting="false"
        alignment="left"
        :width="88"
        :word-wrap-enabled="true"
        cell-template="lmrUeTemplate"
      />

      <DxColumn
        name="lmr_ue_sum"
        :caption="$t('chainsList.% LMR UE (sumatorio)')"
        :allow-sorting="false"
        alignment="left"
        :width="102"
        :word-wrap-enabled="true"
        cell-template="lmrUeTemplate"
      />

      <DxColumn
        name="arfd"
        :caption="$t('chainsList.% ARFD')"
        :allow-sorting="false"
        alignment="left"
        :width="70"
        :word-wrap-enabled="true"
        cell-template="lmrUeTemplate"
      />

      <DxColumn
        name="arfd_sum"
        :caption="$t('chainsList.% ARFD (sumatorio)')"
        :allow-sorting="false"
        alignment="left"
        :width="115"
        :word-wrap-enabled="true"
        cell-template="lmrUeTemplate"
      />

      <DxColumn
        name="active_sus"
        :caption="$t('chainsList.Nº Sustancias Activas')"
        :allow-sorting="false"
        alignment="left"
        :width="99"
        :word-wrap-enabled="true"
        cell-template="lmrUeTemplate"
      />

      <DxColumn
        name="black_list"
        :caption="$t('chainsList.Lista Negra')"
        :allow-sorting="false"
        alignment="left"
        :width="67"
        :word-wrap-enabled="true"
        cell-template="lmrUeTemplate"
      />

      <DxColumn
        name="sust_matrz"
        :caption="$t('chainsList.Nº Sust Por Matriz')"
        :allow-sorting="false"
        alignment="left"
        :word-wrap-enabled="true"
        cell-template="lmrUeTemplate"
      />

      <DxColumn
        name="lmr_matrz"
        :caption="$t('chainsList.% LMR por Matriz')"
        :allow-sorting="false"
        alignment="left"
        :word-wrap-enabled="true"
        cell-template="lmrUeTemplate"
      />

      <DxColumn
        name="lmr_matriz_value"
        :caption="$t('chainsList.Valor LMR por Matriz')"
        :allow-sorting="false"
        alignment="left"
        :word-wrap-enabled="true"
        cell-template="lmrUeTemplate"
      />

      <DxColumn
        name="prp_ul"
        :caption="$t('chainsList.PRP-UL % ')"
        :allow-sorting="false"
        alignment="left"
        :width="64"
        :word-wrap-enabled="true"
        cell-template="lmrUeTemplate"
      />

      <DxColumn
        name="prp_ul_sum"
        :caption="$t('chainsList.PRP-UL % (sumatorio)')"
        :allow-sorting="false"
        alignment="left"
        :width="106"
        :word-wrap-enabled="true"
        cell-template="lmrUeTemplate"
      />

      <DxColumn
        name="adi"
        :caption="$t('chainsList.ADI %')"
        :allow-sorting="false"
        alignment="left"
        :width="58"
        :word-wrap-enabled="true"
        cell-template="lmrUeTemplate"
      />

      <DxColumn
        name="confirmation"
        :caption="$t('confirmation')"
        :allow-sorting="false"
        alignment="left"
        :word-wrap-enabled="true"
        :fixed="true"
        fixed-position="left"
        cell-template="confirmationTemplate"
      />

      <template #lmrUeTemplate="{ data }">
        <div
          v-if="
            data.data[`Resultado ` + data.column.caption] !==
            undefined
          "
          style="text-align: center"
        >
          <img
            width="17"
            height="17"
            :src="
              data.data[`Resultado ` + data.column.caption]
                ? getDotColorImage('green')
                : getDotColorImage('red')
            "
          />
        </div>
        <div v-else style="text-align: center">-</div>
      </template>

      <template #confirmationTemplate="{ data }">
        <div style="text-align: center">
          <i
            v-if="!data.data.Confirmado"
            style="color: #a80d0b; font-size: 27px"
            class="f7-icons"
          >
            xmark_circle_fill
          </i>
          <i
            v-if="data.data.Confirmado"
            style="color: green; font-size: 27px"
            class="f7-icons"
          >
            checkmark_alt_circle_fill
          </i>
        </div>
      </template>

      <DxExport :enabled="true" />
    </DxDataGrid>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import {
  DxDataGrid,
  DxColumn,
  DxPager,
  DxPaging,
  DxScrolling,
  DxExport,
  DxSelection,
  DxSearchPanel,
  DxHeaderFilter,
  DxStateStoring,
} from 'devextreme-vue/data-grid';

import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';

export default {
  name: 'ChainsTable',
  components: {
    DxDataGrid,
    DxColumn,
    DxPager,
    DxPaging,
    DxScrolling,
    DxExport,
    DxSelection,
    DxSearchPanel,
    DxHeaderFilter,
    DxStateStoring,
  },
  data() {
    return {
      gridInstance: null,
    };
  },
  computed: {
    ...mapState('foodSamples', ['europeanChains']),
  },
  methods: {
    getDotColorImage(color) {
      return require(`../../../../../assets/dot-colors/${color}_new.svg`)
        .default;
    },
    getGridInstance() {
      return this.$refs.dataGrid?.instance || null;
    },
    onGridInitialized(e) {
      this.gridInstance = e.component; // instancia real dxDataGrid
    },
    openHeaderFilter(dataField, anchorEl) {
      const grid = this.gridInstance;
      if (!grid) return;

      const colIndex = grid.getVisibleColumnIndex(dataField);
      if (colIndex < 0) return;

      // 1) abre el popup
      grid
        .getController('headerFilter')
        .showHeaderFilterMenu(colIndex);

      // 2) cuando el popup ya está renderizado, lo reposicionas al lado del botón
      this.$nextTick(() => {
        const popup = grid
          .getView('headerFilterView')
          ?.getPopupContainer?.();
        if (!popup || !anchorEl) return;

        popup.option('position', {
          my: 'left top', // esquina del popup
          at: 'right top', // esquina del botón
          of: anchorEl, // elemento ancla (botón)
          offset: '8 3', // separación en px
          collision: 'flipfit',
        });
        popup.option('wrapperAttr', {
          class: 'custom-header-filter-popup',
        });
        popup.option({
          width: 270,
          height: 360,
        });
      });
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Companies');
      worksheet.columns = [
        { width: 40 },
        { width: 40 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
      ];
      exportDataGrid({
        component: e.component,
        worksheet,
        keepColumnWidths: false,
        topLeftCell: { row: 2, column: 2 },
        customizeCell: ({ gridCell, excelCell }) => {
          if (gridCell.rowType === 'data') {
            if (gridCell.column.caption === this.$t('chain')) {
              excelCell.value = gridCell.data.Supermercado;
            } else if (
              gridCell.column.caption === this.$t('confirmation')
            ) {
              excelCell.value = gridCell.data.Confirmado
                ? this.$t('yes')
                : this.$t('no');
            } else if (
              gridCell.data[`Resultado ${gridCell.column.caption}`]
            ) {
              excelCell.value = this.$t('green');
            } else if (
              gridCell.data[
                `Resultado ${gridCell.column.caption}`
              ] === false
            ) {
              excelCell.value = this.$t('red');
            } else {
              excelCell.value = '-';
            }
          }
        },
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: 'application/octet-stream' }),
            `besafer-${this.$t(
              'chains'
            )}-${new Date().toLocaleString()}.xlsx`
          );
        });
      });
      e.cancel = true;
    },
    // onToolbarPreparing(e) {
    //   const toolbarItems = e.toolbarOptions.items;
    //   e.toolbarOptions.elementAttr = {
    //     class: 'custom-toolbar',
    //   };
    //   toolbarItems.forEach((item) => {
    //     if (item.name === 'searchPanel') {
    //       item.location = 'after';
    //     }
    //     if (item.name === 'exportButton') {
    //       item.location = 'after';
    //     }
    //   });
    //   toolbarItems.push({
    //     name: 'Filtros',
    //     location: 'after',
    //     widget: 'dxButton',
    //     locateInMenu: 'never',
    //     options: {
    //       text: '',
    //       icon: '././static/icons/ic_filter.svg',
    //       width: 41,
    //       elementAttr: {
    //         class: 'btn-filtrar',
    //       },
    //       onClick: (ev) =>
    //         this.openHeaderFilter('Supermercado', ev.element),
    //     },
    //   });
    // },
    onToolbarPreparing(e) {
      const items = e.toolbarOptions.items;

      const searchItem = items.find((i) => i.name === 'searchPanel');
      const exportItem = items.find((i) => i.name === 'exportButton');

      // quitamos los originales
      e.toolbarOptions.items = items.filter(
        (i) => i !== searchItem && i !== exportItem
      );

      if (searchItem) {
        searchItem.location = 'after';
      }
      if (exportItem) {
        exportItem.location = 'after';
        exportItem.cssClass = 'tb-export-item'; // <-- CLASE SOLO PARA EXCEL
      }

      // insertamos en el orden EXACTO
      e.toolbarOptions.items.push(
        searchItem,
        {
          name: 'Filtros',
          location: 'after',
          widget: 'dxButton',
          locateInMenu: 'never',
          cssClass: 'tb-filter-item',
          options: {
            icon: '././static/icons/ic_filter.svg',
            elementAttr: { class: 'btn-filtrar' },
            onClick: (ev) =>
              this.openHeaderFilter('Supermercado', ev.element),
          },
        },
        exportItem
      );
    },
    ...mapActions('foodSamples', ['setSampleDetails']),
  },
};
</script>

<style>
/* .custom-grid-chains .dx-toolbar-before {
  display: grid;
  grid-template-columns: 123px 120px 6px 43px 36px;
  grid-template-rows: repeat(1, 1fr);
  row-gap: 24px;
  align-items: center;
  box-sizing: border-box;
}
.custom-grid-chains .dx-toolbar-before :nth-child(1) {
  grid-row: 1;
  grid-column: 4;
}
.custom-grid-chains .dx-toolbar-before :nth-child(2) {
  grid-row: 1;
  grid-column: 1 / span 2;
}
.custom-grid-chains .dx-toolbar-before :nth-child(3) {
  grid-row: 1;
  grid-column: 5;
} */
/* .custom-grid-chains .dx-toolbar-after {
  display: grid;
  grid-template-columns: 123px;
  grid-template-rows: repeat(1, 1fr);
  row-gap: 24px;
  align-items: center;
  box-sizing: border-box;
}
.custom-grid-chains .dx-toolbar-after :nth-child(1) {
  grid-row: 1;
  grid-column: 1;
} */
.custom-grid-chains .dx-toolbar-after .dx-button {
  height: 40px !important;
  width: 40px !important;
  border: 1px solid #00346a !important;
  border-radius: 10px !important;
  background-color: #fff !important;
  padding: 3px !important;

  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.custom-grid-chains .dx-toolbar-after {
  display: flex !important;
  justify-content: flex-end;
  align-items: center;
}
.custom-grid-chains .dx-datagrid-search-panel.dx-textbox {
  height: 40px;
  border-radius: 24px;
  border: 1px solid #00346a;
}
.custom-grid-chains
  .dx-toolbar.dx-widget.dx-visibility-change-handler.dx-collection {
  padding: 20px 0px 9px;
}
.custom-grid-chains .dx-datagrid-search-panel {
  margin-bottom: 0 !important;
}
.custom-grid-chains .dx-toolbar-after .dx-toolbar-item {
  padding-left: 2px !important;
  padding-right: 7px !important;
}
/* SOLO afectar a los items Filtrar y Excel */
.custom-grid-chains .dx-toolbar-after .tb-filter-item,
.custom-grid-chains .dx-toolbar-after .tb-export-item {
  margin: 0 !important;
  padding: 0 !important;
}

/* quitar padding interno del contenedor del item (DevExtreme lo mete aquí) */
.custom-grid-chains
  .dx-toolbar-after
  .tb-filter-item
  .dx-toolbar-item-content,
.custom-grid-chains
  .dx-toolbar-after
  .tb-export-item
  .dx-toolbar-item-content {
  padding: 1px !important;
}

.custom-grid-chains .dx-datagrid-text-content {
  white-space: pre-wrap !important;
}
.custom-header-filter-popup.dx-popup-wrapper > .dx-overlay-content {
  border-radius: 10px !important;
}
.custom-header-filter-popup .dx-overlay-content .dx-popup-content {
  height: 85% !important;
}
.custom-header-filter-popup .dx-popup-bottom.dx-toolbar {
  padding: 3px 40px;
}
.custom-header-filter-popup .dx-popup-content .dx-scrollable {
  padding: 16px 8px !important;
}
.custom-header-filter-popup .dx-texteditor.dx-editor-outlined {
  border-radius: 24px !important;
}
.custom-header-filter-popup
  .dx-texteditor-input-container
  > input.dx-texteditor-input {
  padding-left: 30px !important;
}
/* oculta el icono pero mantiene headerFilter habilitado */
.custom-grid-chains .dx-header-filter {
  display: none !important;
}
</style>
